import { render, staticRenderFns } from "./Simulators.vue?vue&type=template&id=5fa91ffd"
import script from "./Simulators.vue?vue&type=script&lang=js"
export * from "./Simulators.vue?vue&type=script&lang=js"
import style0 from "./Simulators.vue?vue&type=style&index=0&id=5fa91ffd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports